// extracted by mini-css-extract-plugin
module.exports = {"genres__header":"genres_genres__header__vBNaU","genres__search":"genres_genres__search__pp1vn"};